import { Injectable, Optional, Inject } from '@angular/core';
import { TranslateMessageFormatCompiler, MESSAGE_FORMAT_CONFIG, MessageFormatConfig } from 'ngx-translate-messageformat-compiler';
import { MessageFunction } from '@messageformat/core';

/**
 * Кастомный компилятор для ngx-translate, который маппит код языка 'ua' на 'uk'
 * для правил плюризации, сохраняя при этом использование 'ua' в остальной части приложения.
 *
 * Это необходимо, потому что ngx-translate-messageformat-compiler использует стандартные
 * коды языков ISO 639-1, где украинский - это 'uk', а не 'ua'.
 */
@Injectable()
export class TranslateCompilerWithUaMapping extends TranslateMessageFormatCompiler {
  private readonly LANG_MAP: Record<string, string> = {
    ua: 'uk',
  };

  constructor(@Optional() @Inject(MESSAGE_FORMAT_CONFIG) config?: MessageFormatConfig) {
    super(config);
  }

  /**
   * Получить код языка для плюризации.
   * Маппит 'ua' на 'uk' для правильной работы правил плюризации.
   */
  private getPluralizationLang(lang: string): string {
    return this.LANG_MAP[lang] || lang;
  }

  /**
   * Переопределяем метод compile, чтобы использовать правильный код языка для плюризации.
   */
  override compile<Result extends MessageFunction<'string'> | string = MessageFunction<'string'>>(
    value: string,
    lang: string,
  ): Result {
    const pluralizationLang = this.getPluralizationLang(lang);
    return super.compile(value, pluralizationLang) as Result;
  }

  /**
   * Переопределяем метод compileTranslations, чтобы использовать правильный код языка для плюризации.
   */
  override compileTranslations(translations: any, lang: string): any {
    const pluralizationLang = this.getPluralizationLang(lang);
    return super.compileTranslations(translations, pluralizationLang);
  }
}
